import React from 'react'
import styled from 'styled-components'
import { User } from 'redux/user/userTypes'
import Text from 'core-system/Text'

const TextContainer = styled(Text)`
  font-weight: 500;
  margin-bottom: 0;
`

interface WelcomeMessageProps {
  user: User
}

const WelcomeMessage = (props: WelcomeMessageProps) => {
  const { user } = props

  const capitalize = (str: string) => {
    if (!str) {
      return ''
    }
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  if (!user || !user.firstName) {
    return null
  }

  return (
    <TextContainer variant='h2'>
      Welcome {capitalize(user.firstName)} {capitalize(user.lastName)}!
    </TextContainer>
  )
}

export default WelcomeMessage
